module.exports = __webpack_public_path__ + "img/appcode-sun.a387de2.jpg";